export default "__VITE_ASSET__CwIoXpT___"